<template>
  <el-container>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
        <el-row>
          <el-col :span="8">
            <el-form-item label="订阅者邮箱" prop="subscriberEmail" class="cls-col">
              <el-input v-model="searchData.subscriberEmail" placeholder="订阅者邮箱" size="small" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
          :data="OpenclassData"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="selection"
            width="50">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="60"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="subscriberEmail"
            label="订阅者邮箱"
        >
       </el-table-column>
        <el-table-column
            prop="subscriberName"
            label="姓名"
        >
       </el-table-column>
      <el-table-column
            prop="createTime"
            label="订阅时间"
        >
       </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200"
        >
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="updateBlogcategory(scope.row)">修改</el-button> -->
            <el-button @click="deleteBlogSubscribe(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        OpenclassData: [],
        href: '',
        searchData: {
          size: 10,
          page: 1,
          subscriberEmail:'',
          orgCode: 'blcuonline'
        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      addBlogCa() {
        this.$router.push({
          name: 'addblogcategory',
          params: {'title': '添加订阅者内容！'}
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].categoryId;
        }
      },
      updateBlogcategory(row) {
        console.log("row:",row);
        this.$router.push({
          name: 'addblogcategory',
          params: row
        });
      },
       deleteBlogSubscribeMore() {
        let length = this.multipleSelection.length;
        this.$confirm('此操作将删除' + length + '条订阅者, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = {'categoryIdList': multipleSelection};
          https.fetchPost('/webBlogCategory/deleteCategory', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteBlogSubscribe(index, row) {
        this.$confirm('此操作将删除该订阅者, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            'id': row.id
            };
          https.fetchPost('/webBlog/deleteBlogSubscriber', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
      
        let params = this.searchData;
        console.log("params:",params);
        https.fetchPost('webBlog/getBlogSubscriberList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.OpenclassData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
</style>
